
import { memo } from 'react'
import styles from './index.module.less'
import { FlowSheets } from './FlowSheetCard/FlowSheets'
import classNames from 'classnames'
import { MaterialBalances } from './MaterialBalance/MaterialBalances'
import { OPermission } from '@/components/OPermission/OPermission'
import { ROLE_GENERAL } from '@/components/OPermission/PlanPermission'


export default memo(function ProjectWorkspace() {
  return (
    <div className={styles.container}>
      <OPermission permissions={ROLE_GENERAL}>
        <FlowSheets />
        <MaterialBalances />
      </OPermission>
    </div>
  )
})
